module.exports = __webpack_public_path__ + "static/media/UploadButton.82fff51d.less";